import simpleStorage from '@/utils/simpleStorage'

import {REFERRAL_ID_KEY} from './const'

export default function setReferraId(id: string) {
  return simpleStorage.set(REFERRAL_ID_KEY, id)
}
